import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { TRANSACTION_DIRECTION, MONEY_COLOR } from './constants';
import { formatTransactionAmount } from './utils';

export default function Money({ amount, direction, isPayment = false }) {
  const color =
    direction === TRANSACTION_DIRECTION.CREDIT ? MONEY_COLOR.GREEN : MONEY_COLOR.PRIMARY;
  return (
    <Text
      color={color}
      size="xl"
      weight="medium"
      whiteSpace="nowrap"
    >
      {formatTransactionAmount(direction, amount, isPayment)}
    </Text>
  );
}

Money.propTypes = {
  amount: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  isPayment: PropTypes.bool
};
